import $ from 'jquery'

/**
 * Header
 */
export default el => {
  var pastHeaderMenuPos = 0
  $(window).on('scroll load', function () {
    const scrollPos = $(window).scrollTop() + $(window).height()
    const footerPos = $(el).offset().top + 33

    var headerMenuPos = 0
    if (scrollPos >= footerPos) {
      headerMenuPos = scrollPos - footerPos
    }

    if (pastHeaderMenuPos !== headerMenuPos) {
      pastHeaderMenuPos = headerMenuPos

      $('.js-header-left-bottom-menu').css({
        top: $(window).height() - 125 - headerMenuPos
      })
    }
  })

  if (document.querySelector('.clode-modal')) {
    document.querySelector('.clode-modal').addEventListener('click', function (e) {
      document.querySelector('.newsletter-msg-modal').style.display = 'none'
      document.body.classList.remove('overlay-newsletter')
    })
  }
}

$(document).ready(function () {
  // Show or hide the button based on scroll position
  $(window).on('scroll', function () {
    if ($(this).scrollTop() > 300) {
      $('#returnToTop').fadeIn()
    } else {
      $('#returnToTop').fadeOut()
    }
  })

  // Scroll to the top when the button is clicked
  $('#returnToTop').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 800)
    return false // Prevent default action
  })
})
